/**
 * Which of an arrangement's audio previews was played, using the values the API expects
 */
export const LessonPreviewType = {
  PianoOnly: "piano_only",
  WithBackingTrack: "with_backing_track",
} as const;

export type LessonPreviewType = typeof LessonPreviewType[keyof typeof LessonPreviewType];
